module.exports = __webpack_public_path__ + "img/charge_takeup.6c70db90.png";